import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';
import PrincipalIdRuleset from '../../business/ruleset/PrincipalIdRuleset';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { RulesetResult } from '../../business/rules';

const {
  formField: { principalType },
} = loanFormModel;

export class PrincipalIdDocumentFileNameValidation implements ValidationSchema {
  public name = 'file_name';
  public label = '';
  public type = 'string';
  public required = {
    message: '',
    value: true,
  };
  public nullable = false;

  public when(schema: any, ...args: any[]) {
    return schema.test(
      'check-required-if-undefined',
      'This document is required',
      function (value) {
        const application: Partial<ApplicationFormValues> = this.from[1].value;

        const result: RulesetResult = PrincipalIdRuleset.setPrincipalId(
          this.parent.id
        ).evaluate(application);
        if (result & RulesetResult.REQUIRED) {
          return value != undefined && value != null && value !== '';
        }
        return true;
      }
    );
  }
}

export default new Validation(new PrincipalIdDocumentFileNameValidation());
